import { DataSource, Image, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTariffQuickInfo extends Layout {
    imageRedirectToTariffManagement: Image;
    panelTariff: Panel;
    sourceTariffLookup: DataSource;
    textboxFallbackTariffId: Textbox;
    textboxFallbackTariffName: Textbox;
    textboxTariffId: Textbox;
    textboxTariffName: Textbox;
}
